import ApiGael from "@/services/apiGael.service";
import { FETCH_ALL } from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END
} from "@/store/mutations/mutations.type";

const state = {
  fornecedores: {
    data: []
  },
  isFetchingFornecedores: false
};

const getters = {
  fornecedores(state) {
    return state.fornecedores;
  },
  isFetchingFornecedores(state) {
    return state.isFetchingFornecedores;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiGael.query("fornecedores/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingFornecedores = true;
  },
  [SET_ALL](state, fornecedores) {
    state.fornecedores = fornecedores;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingFornecedores = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
